import { Flex, Icon, Menu, MenuButton, MenuList, Text } from "@chakra-ui/react";

import PaginationDownSvg from "@/assets/svg/pagination-down.svg";

const rowsLimits = [10, 15, 25, 30, 35, 50, 75];

const LimitMenu = ({ selectedLimit, onSelectLimitHandler }) => {
  return (
    <Menu>
      {({ isOpen, onClose }) => (
        <>
          <MenuButton>
            <Flex
              align={"center"}
              columnGap={"8px"}
              borderBottomWidth={"1px"}
              borderColor={"grey"}
            >
              <Text>{selectedLimit}</Text>
              <Icon
                as={PaginationDownSvg}
                transform={isOpen ? "rotate(180deg)" : "rotate(0deg)"}
                transition={"all 0.4s ease-in-out"}
              />
            </Flex>
          </MenuButton>
          <MenuList minW={"50px"} zIndex={20}>
            <Flex direction={"column"}>
              {rowsLimits?.map((item) => (
                <Text
                  w={"100%"}
                  key={item}
                  cursor={"pointer"}
                  onClick={() => onSelectLimitHandler(item, onClose)}
                  px={"8px"}
                  _hover={{ bg: "lightBlue2" }}
                >
                  {item}
                </Text>
              ))}
            </Flex>
          </MenuList>
        </>
      )}
    </Menu>
  );
};

export default LimitMenu;
